<template>
  <div>
    <a
        class="hover:text-blueGray-500 text-blueGray-700 px-3 py-2 flex items-center text-lg uppercase font-bold"
        href="#pablo"
        ref="btnDropdownRef"
        style="font-size:18px"
        v-on:click="toggleDropdown($event)"
    >
      3UTR APA Events
    </a>
    <div
        ref="popoverDropdownRef"
        class="bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg min-w-48"
        v-bind:class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
      }"
    >
      <router-link
          to="/3utrquan"
          class="text-lg py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        Quantiation
      </router-link>
      <router-link
          to="/3utrdiff"
          class="text-lg py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        Differential analysis
      </router-link>
      <router-link
          to="/apa_rna"
          class="text-lg py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        APA-RNA Expression Pearson relative
      </router-link>
      <router-link
          to="/apa_snp"
          class="text-lg py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
      >
        APA-SNP aQTL
      </router-link>
    </div>
  </div>
</template>
<script>
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      dropdownPopoverShow: false,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    toggleDropdown(event) {
      event.preventDefault();
      event.stopPropagation();
      this.dropdownPopoverShow = !this.dropdownPopoverShow;
      if (this.dropdownPopoverShow) {
        createPopper(
          this.$refs.btnDropdownRef,
          this.$refs.popoverDropdownRef,
          {
            placement: "bottom-start",
          }
        );
      }
    },
    handleClickOutside(event) {
      if (!this.dropdownPopoverShow) return;

      const btn = this.$refs.btnDropdownRef;
      const menu = this.$refs.popoverDropdownRef;

      if (!btn || !menu) return;
      if (!btn.contains(event.target) && !menu.contains(event.target)) {
        this.dropdownPopoverShow = false;
      }
    },
  },
};
</script>
